export interface CountryData {
  code: string;
  name: string;
  iso2: string;
}

// Import the country data from the JSON file using absolute path
import countriesJson from "@/utils/countries.json";

// Type assertion to ensure the imported JSON matches our interface
export const countries: CountryData[] = countriesJson as CountryData[];
